var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55155 13.405C2.27955 13.032 2.14355 12.845 2.04955 12.485C1.98609 12.1645 1.98609 11.8346 2.04955 11.514C2.14355 11.153 2.27955 10.966 2.55155 10.594C4.04055 8.54902 7.30455 4.99902 12.0015 4.99902C16.6985 4.99902 19.9625 8.54902 21.4515 10.593C21.7235 10.966 21.8595 11.153 21.9535 11.513C22.017 11.8336 22.017 12.1635 21.9535 12.484C21.8595 12.845 21.7235 13.032 21.4515 13.404C19.9625 15.449 16.6985 18.999 12.0015 18.999C7.30455 18.999 4.04055 15.449 2.55155 13.405Z",
    stroke: "#84878A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 15.999C13.0628 15.999 14.0802 15.5776 14.8304 14.8274C15.5805 14.0773 16.002 13.0599 16.002 11.999C16.002 10.9382 15.5805 9.92074 14.8304 9.1706C14.0802 8.42045 13.0628 7.99902 12.002 7.99902C10.9411 7.99902 9.92367 8.42045 9.17353 9.1706C8.42338 9.92074 8.00195 10.9382 8.00195 11.999C8.00195 13.0599 8.42338 14.0773 9.17353 14.8274C9.92367 15.5776 10.9411 15.999 12.002 15.999Z",
    stroke: "#84878A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.6c2aaff3d9bdfa5ee53d91047d0a9df0.svg";
export { ForwardRef as ReactComponent };